import React, { useEffect, useState } from 'react';
import Menuitems from './Menuitem';
import { Link, useLocation } from 'react-router-dom';

function Sidebar2({ isSidebar, setIsSidebar }) {
  const userType = localStorage.getItem("userType") || "Admin";

  const filteredMenuItems = Menuitems.filter((item) => {
    if (!item.requiredRole) return true;
    if (item.requiredRole === "All") return true;
    return item.requiredRole === userType;
  }).map((item) => ({
    ...item,
    submenus: item.submenus?.filter((submenu) => {
      if (!submenu.requiredRole) return true;
      if (submenu.requiredRole === "All") return true;
      return submenu.requiredRole === userType;
    })
  }));

  const [submenus, setSubmenus] = useState(
    filteredMenuItems.filter((item) => item.submenus).map((item) => ({
      id: item.id,
      isOpen: false,
    }))
  );

  const location = useLocation();

  const handleKeyDown = (event, submenuId) => {
    if (event.key === "ArrowUp" || event.key === "ArrowDown") {
      event.preventDefault();
      toggleSubmenu(submenuId);
    }
  };

  const toggleSubmenu = (submenuId) => {
    setSubmenus((prevSubmenus) =>
      prevSubmenus.map((submenu) => ({
        ...submenu,
        isOpen: submenu.id === submenuId ? !submenu.isOpen : false,
      }))
    );
  };

  const handleCloseSubmenus = () => {
    setSubmenus(submenus.map((submenu) => ({ ...submenu, isOpen: false })));
  };

  const handleLinkClick = () => {
    if (window.innerWidth <= 768) { // Only close the sidebar for mobile screens
      setIsSidebar(false);
    }
  };

  useEffect(() => {
    // Log whenever the route changes
    console.log("Route changed:", location.pathname);
    handleCloseSubmenus();
    console.log(isSidebar);
  }, [location]);

  return (
    <div className={`sidebar-left-links ${isSidebar ? 'active' : ''}`}>
      <ul className="nav-links">
        {filteredMenuItems.map((item) => (
          <li
            className={`nav-link ${
              submenus.find((submenu) => submenu.id === item.id)?.isOpen
                ? "active"
                : ""
            }`}
            key={item.id}
          >
            {item.submenus ? (
              <React.Fragment>
                <div
                  tabIndex="0"
                  onKeyDown={(event) => handleKeyDown(event, item.id)}
                  onClick={() => toggleSubmenu(item.id)}
                  aria-expanded={
                    submenus.find((submenu) => submenu.id === item.id)
                      ?.isOpen || false
                  }
                  aria-haspopup="true"
                >
                  {item.label}
                  <span
                    className={`arrow ${
                      submenus.find((submenu) => submenu.id === item.id)
                        ?.isOpen
                        ? "open"
                        : ""
                    }`}
                  />
                </div>
                {submenus.find((submenu) => submenu.id === item.id)
                  ?.isOpen && (
                  <ul className="nav-sub-links">
                    {item.submenus.map((submenu) => (
                      <li className="nav-sub-link" key={submenu.id}>
                        <Link to={submenu.link} onClick={handleLinkClick} alt="img-alt">
                          <img src={submenu.img} />
                          <div className="sub-menu-link-right">
                            <h2>{submenu.label}</h2>
                            <p>{submenu.desc}</p>
                          </div>
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
              </React.Fragment>
            ) : (
              <Link to={item.link} onClick={handleLinkClick}>
                {item.label}
              </Link>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Sidebar2;
